var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"flat":"","hide-table-header":"","paginated":"","columns":_vm.columns,"loading":_vm.loading,"items":_vm.rows,"server":true,"server-total":_vm.total,"currentPage":_vm.pagination.page},on:{"prev":_vm.onPrev,"next":_vm.onNext},scopedSlots:_vm._u([{key:"createdAt",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("date")(item.createdAt,'DD/MM/YYYY HH:mm'))+" ")]}},{key:"otm",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"uppercase"},[_vm._v(_vm._s(item.otm))])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }